import { useState, useEffect } from "react";

/**
 * Active dark mode follows the same sources as $.quosal.ui.getDarkMode (cookie → body class + toggle).
 * Do not read HasDarkmodeEnabled here; it can disagree with the cookie and cause split UI (e.g. dark grid rows on a light page).
 */
export function readDarkModeActiveFromDom() {
	if (typeof document !== "undefined" && document.body.classList.contains("darkMode")) {
		return true;
	}

	const $toggle = $("#dark-toggle[type=checkbox]");
	if ($toggle.length) {
		return !!$toggle.prop("checked");
	}

	return false;
}

const useDarkMode = () => {
	const [darkMode, setDarkMode] = useState(() => readDarkModeActiveFromDom());

	useEffect(() => {
		const handleChange = function () {
			setDarkMode(this.checked);
		};
		setTimeout(() => {
			const $checkbox = $("#dark-toggle[type=checkbox]");
			$checkbox.on("change", handleChange);
		}, 1000);

		return () => {
			const $checkbox = $("#dark-toggle[type=checkbox]");
			$checkbox.off("change", handleChange);
		};
	}, []);

	return darkMode;
};

export default useDarkMode;
